module.exports = __webpack_public_path__ + "img/sa-icon.61fd8663.svg";